/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { UserOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import Text from 'src/components/ts-components/Text'

/**
 * Profile empty state shown when the user has no associated player profiles.
 * View-only — the gating decision lives in ProfilePage via
 * `hasNoAssociatedPlayers`.
 */
const NoPlayerProfile = () => (
  <div css={cardStyle}>
    <div css={contentStyle}>
      <UserOutlined css={iconStyle} />
      <Text variant='paragraphLarge' weight='medium' color={colors.NEUTRAL_0}>
        {capitalizeWords('No Player Profile Associated')}
      </Text>
      <Text variant='paragraphXSmall' color={colors.NEUTRAL_50}>
        Contact your team manager or league administrator if a player profile
        needs to be linked to your account. You must receive and accept an email
        invite for each team.
      </Text>
    </div>
  </div>
)

export default NoPlayerProfile

const cardStyle = css`
  width: 100%;
  height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 8px;
  background-color: ${colors.SECONDARY_400};
`

const contentStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  text-align: center;
`

const iconStyle = css`
  font-size: 40px;
  color: ${colors.NEUTRAL_100};
`
